module.exports = __webpack_public_path__ + "media/images/sk1-251f034e3b1d92d484734ff3aa3fdf6c.svg";